// extracted by mini-css-extract-plugin
export var arrow = "_31-6";
export var changeItem = "_31-3";
export var changesHeader = "_31-1";
export var changesList = "_31-2";
export var container = "_31-0";
export var pathLabel = "_31-4";
export var value = "_31-7";
export var valuesContainer = "_31-5";